import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './style.css';
import Udghoshlogo from './Udghosh_Logo.png';
import { db } from '../../config/firebase';
import { collection, addDoc } from 'firebase/firestore';

const REGISTER_URL =
  "https://unstop.com/internships/campus-ambassador-internship-udghosh-1728653?lb=use17Prx&utm_medium=Share&utm_source=WhatsApp";

const navLinks = [
  { label: 'Home',       href: '#' },
  { label: 'Featured',   href: '#featured' },
  { label: 'Gallery',    href: '#gallery' },
  { label: 'Sponsors',   href: '#sponsors' },
];

const socials = [
  {
    label: 'Facebook',
    href:  'https://www.facebook.com/udghosh.iitk',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
      </svg>
    ),
  },
  {
    label: 'Instagram',
    href:  'https://www.instagram.com/udghosh_iitk/?hl=en',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
        <circle cx="12" cy="12" r="4.5"/>
        <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
      </svg>
    ),
  },
  {
    label: 'LinkedIn',
    href:  'https://www.linkedin.com/company/udghosh-iit-kanpur-fest/mycompany/',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
        <circle cx="4" cy="4" r="2"/>
      </svg>
    ),
  },
  {
    label: 'YouTube',
    href:  'https://www.youtube.com/channel/UCWA2to9SqSEWHOU7MmiTPCw',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 001.46 6.42 29 29 0 001 12a29 29 0 00.46 5.58 2.78 2.78 0 001.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.96A29 29 0 0023 12a29 29 0 00-.46-5.58z"/>
        <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#090909"/>
      </svg>
    ),
  },
  {
    label: 'Twitter / X',
    href:  'https://twitter.com/udghoshiitk23',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    ),
  },
  {
    label: 'WhatsApp',
    href:  'https://whatsapp.com/channel/0029Vb5lN5wHQbS9nLwj9A0d',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    ),
  },
];

const Footer = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const opinionCollectionRef = collection(db, 'opinions');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!formData.name || !formData.message || !formData.email) return;
      await addDoc(opinionCollectionRef, {
        Name:    formData.name,
        Email:   formData.email,
        Message: formData.message,
      });
      setFormData({ name: '', email: '', message: '' });
      setSubmitted(true);
      setTimeout(() => setSubmitted(false), 4000);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <footer className="udg-footer" id="footer">
      {/* Gold top rule */}
      <div className="udg-footer__top-rule" />

      <div className="udg-footer__body">

        {/* ── Brand column ── */}
        <div className="udg-footer__brand">
          <a href="https://udghosh.org.in/" target="_blank" rel="noreferrer" className="udg-footer__logo-link">
            <img src={Udghoshlogo} alt="Udghosh logo" className="udg-footer__logo" />
          </a>
          <p className="udg-footer__brand-name font-display">CA Program</p>
          <p className="udg-footer__brand-sub">
            by{' '}
            <a href="https://udghosh.org.in/" target="_blank" rel="noreferrer">
              Udghosh
            </a>
          </p>
          <a href={REGISTER_URL} className="udg-btn udg-btn-filled udg-footer__register" target="_blank" rel="noreferrer">
            Register
          </a>
        </div>

        {/* ── Nav column ── */}
        <div className="udg-footer__nav">
          <h4 className="udg-footer__col-title">Quick Links</h4>
          <ul className="udg-footer__nav-list">
            {navLinks.map((l) => (
              <li key={l.label}>
                <a href={l.href} className="udg-footer__nav-link">{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* ── Contact form ── */}
        <div className="udg-footer__contact">
          <h4 className="udg-footer__col-title">Your Opinion Matters</h4>
          {submitted ? (
            <motion.p
              className="udg-footer__success"
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
            >
              ✓ Thank you for your feedback!
            </motion.p>
          ) : (
            <form onSubmit={handleSubmit} className="udg-footer__form">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Name"
                required
                className="udg-footer__input"
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email"
                required
                className="udg-footer__input"
              />
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Message"
                required
                rows={4}
                className="udg-footer__textarea"
              />
              <button type="submit" className="udg-btn udg-btn-filled udg-footer__submit">
                Submit
              </button>
            </form>
          )}
        </div>
      </div>

      {/* ── Social icons ── */}
      <div className="udg-footer__socials">
        {socials.map((s) => (
          <a
            key={s.label}
            href={s.href}
            target="_blank"
            rel="noreferrer"
            aria-label={s.label}
            className="udg-footer__social-icon"
          >
            {s.icon}
          </a>
        ))}
      </div>

      {/* ── Copyright ── */}
      <p className="udg-footer__copy">
        Copyright &copy; Udghosh&apos;25 Inc. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
